import * as betroyale from './Carousel.styles.betroyale';
import * as goldenrush from './Carousel.styles.goldenrush';
import * as juicybet from './Carousel.styles.juicybet';
import * as vikingbet from './Carousel.styles.vikingbet';
import * as junglebet from './Carousel.styles.junglebet';
import * as puntcity from './Carousel.styles.puntcity';
import * as fiestabet from './Carousel.styles.fiestabet';
import * as volcanobet from './Carousel.styles.volcanobet';
import * as wellbet from './Carousel.styles.wellbet';
import * as sterlingparker from './Carousel.styles.sterlingparker';
import * as questbet from './Carousel.styles.questbet';
import * as puntgenie from './Carousel.styles.puntgenie';
import * as betprofessor from './Carousel.styles.betprofessor';
import * as sugarcastle from './Carousel.styles.sugarcastle';
import * as oldgill from './Carousel.styles.oldgill';
import * as buffalobet from './Carousel.styles.buffalobet';
import * as templebet from './Carousel.styles.templebet';
import * as slambet from './Carousel.styles.slambet';
import * as betstride from './Carousel.styles.betstride';
import * as gigabet from './Carousel.styles.gigabet';
import * as titanbet from './Carousel.styles.titanbet';
import * as goldenbet888 from './Carousel.styles.goldenbet888';
import * as chromabet from './Carousel.styles.chromabet';
import * as bet777 from './Carousel.styles.bet777';
import * as bet575 from './Carousel.styles.bet575';
import * as betblast from './Carousel.styles.betblast';
import * as hyperbet from './Carousel.styles.hyperbet';
import * as pyramidbet from './Carousel.styles.pyramidbet';
import * as magnumbet from './Carousel.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betroyale,
  goldenrush,
  juicybet,
  vikingbet,
  junglebet,
  puntcity,
  fiestabet,
  volcanobet,
  wellbet,
  sterlingparker,
  questbet,
  puntgenie,
  betprofessor,
  sugarcastle,
  oldgill,
  buffalobet,
  templebet,
  slambet,
  betstride,
  gigabet,
  titanbet,
  goldenbet888,
  chromabet,
  bet777,
  bet575,
  betblast,
  hyperbet,
  pyramidbet,
  magnumbet,
};
